import React, { useState } from 'react';
import { formatPoints } from '../../../utils/helper';

const industryTransactionMap = {
  'White Goods': 10000,
  'Steel': 10000,
  'Battery': 10000,
  'Ceramics': 10000,
  'Construction': 10000,
  'Spare': 10000,
  'Footwear': 10000,
  'Glass & Plywood': 10000,
  'Plywood': 10000,
  "Glass": 10000,
  'Mobile': 20000,
  '2 Wheelers': 12500,
  'Agri Inputs': 8000,
   "FMCG":10000
};

const activityPointsMap = {
  'ERP Daily Sync': {
    Silver: 1000,
    Gold: 1500,
    Platinum: 2000,
    "Founder Club": 2500,
  },
  // 'Onboard Retailers': {
  //   Silver: 125000,
  //   Gold: 250000,
  //   Platinum: 375000,
  //   "Founder Club": 500000,
  // },
  // 'Onboard Retailers': {
  //   Silver: 100000,
  //   Gold: 100000,
  //   Platinum: 100000,
  //   "Founder Club": 100000,
  // },
};

const InvoiceEarningsStatus = localStorage.getItem("InvoiceEarningsStatus");
const industry = localStorage.getItem('industry');
const bonusPointsMap = {
  // 'Refer Brands': {
  //   Silver: 3700000,
  //   Gold: 7500000,
  //   Platinum: 10000000,
  //   "Founder Club": 15000000,
  // },
  // 'Refer Distributors': {
  //   Silver: 500000,
  //   Gold: 1000000,
  //   Platinum: 1500000,
  //   "Founder Club": 2000000,
  // },\
  'Refer Friend': {
    Silver: 50000,
    Gold: 50000,
    Platinum: 50000,
    "Founder Club": 50000,
  },
  'Refer Distributors': {
    Silver: 10000,
    Gold: 10000,
    Platinum: 10000,
    "Founder Club": 10000,
  },
};

const tierMultipliers = {
  Silver: 1,
  Gold: 1.5,
  Platinum: 2,
  "Founder Club": 2.5,
};

const initialActivitiesData = {
  pointsNeeded: 20000,
  activities: [
    {
      title: 'Upload Invoices',
      pointsPerUnit: 100,
      unit: '₹10K invoice value',
      recommended: '₹57L',
      predicted: '₹50L',
      inputValue: 0,
    },
    {
      title: 'ERP Daily Sync',
      pointsPerUnit: 1000,
      unit: 'day',
      recommended: '180 days',
      predicted: null,
      inputValue: 0,
    },
    {
      title: 'Onboard Retailers',
      pointsPerUnit: 125000,
      unit: 'Retailer referral',
      recommended: '5 retailers',
      predicted: null,
      inputValue: 0,
    },
  ],
  bonusActivities: [
    {
      title: 'Refer Friend',
      description: 'Earn upto ₹50K/brand',
      pointsPerUnit: 50000,
      maxPoints: 15000000,
      inputValue: 0,
    },
    {
      title: 'Refer Distributors',
      description: 'Earn upto ₹10K/distributor',
      pointsPerUnit: 10000,
      maxPoints: 2000000,
      inputValue: 0,
    },
  ],
  pointsCoverage: {
    current: 10000,
    total: 20000,
    progress: '50%',
    fraction: '10,000 / 20,000 points',
  },
};

const ActivitiesContent = ({ updateFormData, setActiveSection, formData }) => {
  const isEligibleForERPEarning = localStorage.getItem("iseligibleforERPEarning")?.toLowerCase() === "yes";
  const industry = localStorage.getItem('industry')
  const Avg_Invoice_Disbursed_per_month = localStorage.getItem('Avg_Invoice_Disbursed_per_month')
  const customerTier = localStorage.getItem('customerTier');
  const totalPoints = formData?.RewardsDetails?.totalpoint
  const transactionValue = industryTransactionMap[industry]
  const recomendedRetailers = (totalPoints / 100000)
  const rounded = Math.ceil(recomendedRetailers);
  const tierValue = (tierMultipliers[customerTier] * 100)
  const recommendedValue = (totalPoints / tierValue) * transactionValue
  const currentValue = (Avg_Invoice_Disbursed_per_month * 3)
  const [activitiesData, setActivitiesData] = useState(() => {



    const unitValue = transactionValue / 1000;
    const filteredActivities = initialActivitiesData.activities.filter((activity) => {
      if (activity.title === 'ERP Daily Sync' && !isEligibleForERPEarning) return false;
      if (industry === 'FMCG' && activity.title === 'Onboard Retailers') {
        return false;
      }

      return true;
    });

    const updatedActivities = filteredActivities.map((activity) => {
      if (activity.title === 'Upload Invoices') {
        return { ...activity, unit: `₹${unitValue}K invoice value` };
      } else if (activity.title in activityPointsMap) {
        return {
          ...activity,
          pointsPerUnit: activityPointsMap[activity.title][customerTier] || activity.pointsPerUnit,
        };
      }
      return activity;
    });
    const updatedBonusActivities = initialActivitiesData.bonusActivities.map((bonus) => ({
      ...bonus,
      pointsPerUnit: bonusPointsMap[bonus.title][customerTier] || bonus.pointsPerUnit,
    }));
    return { ...initialActivitiesData, activities: updatedActivities, bonusActivities: updatedBonusActivities };
  });

  const [openActivityIndex, setOpenActivityIndex] = useState(null);
  const [openBonusIndex, setOpenBonusIndex] = useState(null);

  const handleActivityInput = (index, value) => {
    const updatedActivities = [...activitiesData.activities];
    updatedActivities[index] = { ...updatedActivities[index], inputValue: Number(value) };
    setActivitiesData({ ...activitiesData, activities: updatedActivities });
  };

  const handleBonusInput = (index, value) => {
    const updatedBonus = [...activitiesData.bonusActivities];
    updatedBonus[index] = { ...updatedBonus[index], inputValue: Number(value) };
    setActivitiesData({ ...activitiesData, bonusActivities: updatedBonus });
  };

  const toggleActivity = (index) => {
    setOpenActivityIndex(openActivityIndex === index ? null : index);
  };

  const toggleBonusActivity = (index) => {
    setOpenBonusIndex(openBonusIndex === index ? null : index);
  };

  const calculatePoints = (activity, inputValue) => {
    if (activity.title === 'Upload Invoices') {
      const transactionValue = industryTransactionMap[industry] || 10000;
      const multiplier = tierMultipliers[customerTier] || 1;
      const invoiceValue = inputValue * 100000;
      const transactions = invoiceValue / transactionValue;
      return Math.floor(transactions * 100 * multiplier);
    } else if (activity.title in activityPointsMap) {
      const pointsPerUnit = activityPointsMap[activity.title][customerTier] || activity.pointsPerUnit;
      return Math.floor(inputValue * pointsPerUnit);
    } else if (activity.title in bonusPointsMap) {
      const pointsPerUnit = bonusPointsMap[activity.title][customerTier] || activity.pointsPerUnit;
      return Math.floor(inputValue * pointsPerUnit);
    }
    return Math.floor(inputValue * activity.pointsPerUnit);
  };

  const handleContinue = () => {
    const campaignCodes = {
      'Onboard Retailers': 'NTH-CAM002024',
      'ERP Daily Sync': 'NTH-CAM002019',
      'Upload Invoices': 'NTH-CAM002018',
    };

    const bonusCampaignCodes = {
      'Refer Friend': 'NTH-CAM002026',
      'Refer Distributors': 'NTH-CAM002025',
    };

    const formattedData = {
      Activity: activitiesData.activities
        .filter((activity) => activity.inputValue > 0)
        .map((activity) => ({
          activityType: activity.title,
          totalcount: activity.inputValue,
          points: calculatePoints(activity, activity.inputValue),
          campaignCode: campaignCodes[activity.title] || '',
        })),
      BonusActivities: activitiesData.bonusActivities
        .filter((bonus) => bonus.inputValue > 0)
        .map((bonus) => ({
          activityType: bonus.title,
          totalcount: bonus.inputValue,
          points: calculatePoints(bonus, bonus.inputValue),
          campaignCode: bonusCampaignCodes[bonus.title] || '',
        })),
      RewardsDetails: formData?.RewardsDetails || {},
      Timeline: formData?.Timeline || {},
    };

    updateFormData(formattedData);
    setActiveSection('review_timeline');
  };

  const totalEarnedPoints = activitiesData.activities.reduce((sum, activity) => {
    return sum + calculatePoints(activity, activity.inputValue);
  }, 0);

  const progressbar = (totalEarnedPoints / (formData?.points?.need || 20000)) * 100;
  const goalMet = totalEarnedPoints >= (formData?.points?.need || 20000);



  const transactionValues = industryTransactionMap[industry]
  return (
    <main>
      <div className="timeline">
        <div className="timeline-content">
          <div className="timeline-content-inner active" id="activities_timeline">
            <div className="timeline-activities">
              <div className="timeline-activities-box">
                <div className="timeline-activities-box-header">
                  <h4>Earn Additional Points</h4>
                  <p>
                    You need {formatPoints(
                      formData?.points?.need <= formData?.RewardsDetails?.totalpoint
                        ? formData?.points?.need
                        : 0
                    )} more points to achieve your selected reward. Choose activities below to reach your goal:

                  </p>
                </div>
                <div className="timeline-activities-box-top">
                  {activitiesData.activities.map((activity, index) => (
                    <div key={index} className="timeline-activities-box-top-inner">
                      <div
                        className={`timeline-activities-box-middle-box-head ${openActivityIndex === index ? 'active' : ''}`}
                        onClick={() => toggleActivity(index)}
                        style={{ cursor: 'pointer' }}
                      >

                        <div className='timeline-activities-box-middle-box-head-top'>
                          <h4>{activity.title}</h4>
                          {activity.inputValue > 0 && (
                            <span>{formatPoints(calculatePoints(activity, activity.inputValue))} Points</span>
                          )}
                        </div>
                        <p>
                          Earn{' '}
                          <span>
                            {formatPoints(
                              activity.title === 'Upload Invoices'
                                ? 100 * (tierMultipliers[customerTier] || 1)
                                : activityPointsMap[activity.title]?.[customerTier] || activity.pointsPerUnit
                            )}{' '}
                            points
                          </span>{' '}
                          per <span>{activity?.title === "Onboard Retailers" ? "Retailer referral" : `₹${formatPoints(transactionValues)} Invoice value`}</span>
                        </p>
                      </div>
                      <div
                        className={`timeline-activities-box-middle-box-body ${openActivityIndex === index ? 'active' : ''}`}
                      >
                        <p>
                          {activity.title === 'Upload Invoices'
                            ? 'Route more invoices via Progcap to earn points'
                            : activity.title === 'ERP Daily Sync'
                              ? 'Keep your ERP synced with Progcap to earn points'
                              : 'Bring new retailers to the Progcap platform'}
                        </p>
                        <div className="timeline-activities-box-top-inner-body-box">
                          {activity.title === "Upload Invoices" ? (
                            <div className="timeline-activities-box-top-inner-body-box-left">
                              <div className="timeline-activities-box-top-inner-body-box-left-left">
                                <p>Recommended</p>
                                <h4 className="colored">{formatPoints(recommendedValue) || 0}</h4>
                              </div>

                              <div className="timeline-activities-box-top-inner-body-box-left-right">
                                <p>Current</p>
                                <h4>{formatPoints(currentValue) || 0}</h4>
                              </div>

                            </div>
                          ) :
                            <div className="timeline-activities-box-top-inner-body-box-left">
                              <div className="timeline-activities-box-top-inner-body-box-left-left">
                                <p>Recommended</p>
                                <h4 className="colored">{rounded || 0} Retailers</h4>
                              </div>

                            </div>
                          }
                          <div className="timeline-activities-box-top-inner-body-box-right">
                            <p>
                              Enter {activity.unit.includes('invoice') ? 'value' : 'count'}: <span>
                                {activity.unit.includes('invoice') && '₹'}
                                <input
                                  type="number"
                                  value={activity.inputValue || ''}
                                  onChange={(e) => handleActivityInput(index, e.target.value)}
                                  placeholder="0"
                                />
                                {activity.unit.includes('invoice') ? 'L in invoices value' : activity.unit}
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="timeline-activities-box-middle">
                  <h4>Bonus Point Opportunities</h4>
                  <div className="timeline-activities-box-middle-alert">
                    <p>
                      These referral points do not count toward your goal. Points from successful referrals are automatically added to your wallet and can be used to redeem rewards.
                    </p>
                  </div>
                  {activitiesData.bonusActivities.map((bonus, index) => (
                    <div key={index} className="timeline-activities-box-middle-box">
                      <div
                        className={`timeline-activities-box-middle-box-head ${openBonusIndex === index ? 'active' : ''}`}
                        onClick={() => toggleBonusActivity(index)}
                        style={{ cursor: 'pointer' }}
                      >
                        <h4>
                          {bonus.title}
                          {bonus.inputValue > 0 && (
                            <span style={{ marginLeft: '10px', fontSize: '14px', color: '#7767EB' }}>
                              ({formatPoints(bonus.inputValue)} referral)
                            </span>
                          )}
                        </h4>
                        {/* <p> {bonus.description}</p> */}
                        <p>Earn points equal to their 30 day business volume with Progcap</p>
                      </div>
                      <div
                        className={`timeline-activities-box-middle-box-body ${openBonusIndex === index ? 'active' : ''}`}
                      >
                        {/* <p>
                          Refer new {bonus.title.includes('Brands') ? 'brands' : 'distributors'} to join the Progcap ecosystem and earn up to {formatPoints(bonus.pointsPerUnit)} points
                        </p> */}
                        {bonus.title.includes('Friend') ? <p>
                          Earn upto ₹50K/friend
                        </p> : <p>Earn upto &#x20B9;10K/distributor</p>}
                        <div className="timeline-activities-box-middle-box-body-inner">
                          <div className="timeline-activities-box-middle-box-body-inner-left">
                            <label>Number of referrals</label>
                            <input
                              type="number"
                              value={bonus.inputValue || ''}
                              onChange={(e) => handleBonusInput(index, e.target.value)}
                              placeholder="0"
                            />
                          </div>
                          <div className="timeline-activities-box-middle-box-body-inner-right">
                            <p>Points credited 30 days after successful onboarding</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="timeline-points-box-reward">
                  <div className="timeline-points-box-middle">
                    <div className="home-goals-middle-top">
                      <div className="home-goals-middle-top-left">Points coverage</div>
                      <div
                        className="home-goals-middle-top-right"
                        data-progress={totalEarnedPoints / (formData?.points?.need)}
                      >
                        {`${formatPoints(totalEarnedPoints)} / ${formatPoints(formData?.points?.need || 20000)} points`}
                      </div>
                    </div>
                    <div className="home-goals-middle-bottom">
                      <div className="home-goals-progress-container">
                        <div
                          className="home-goals-progress-bar"
                          style={{
                            width: `${progressbar}%`,
                            backgroundColor: goalMet ? '#059669' : '#F1BB49',
                            height: '100%',
                            borderRadius: '4px',
                          }}
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mt-4">
                  <button
                    className="btn btn-full"
                    onClick={handleContinue}
                    disabled={!goalMet}
                    style={{
                      backgroundColor: goalMet ? '#059669' : '#E5E7EB',
                      color: goalMet ? '#FFFFFF' : '#666',
                      opacity: goalMet ? 1 : 0.6,
                      cursor: goalMet ? 'pointer' : 'not-allowed',

                    }}
                  >
                    Select activities to earn points
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default ActivitiesContent;

